const t="https://static.rain.com/icons",c="v1";export{t as baseIconsUrl,c as baseIconsVersion};
//# sourceMappingURL=iconsUrl.js.map
